module.exports = __webpack_public_path__ + "d0958d0b19a3f5750222ec0766b403df.jpg";